import { Badge, Card, HStack, Heading, Icon, IconButton, Stack, Text, Tooltip } from '@chakra-ui/react';
import React, { FC } from 'react';
import { FiTrash2, FiEdit3, FiCheckCircle, FiFileText, FiUsers } from 'react-icons/fi';
import 'moment/locale/es';
import { SurveyStatus } from './types';
import { formatDate } from '../../util/string';
import { useSelector } from 'react-redux';
import { selectIsAdmin } from '../../store/slices/User/selectors';

interface SurveyCardProps {
  id: string;
  title: string;
  createdAt: string;
  status: string;
  responses: number;
  onClick: (id: string) => void;
  onDelete: (id: string) => void;
}

const SurveyCard: FC<SurveyCardProps> = ({
  id,
  title,
  createdAt,
  status,
  responses,
  onClick,
  onDelete,
}) => {
  const isAdmin = useSelector(selectIsAdmin);

  const getStatusLabel = () => {
    if (status === SurveyStatus.PUBLISHED) {
      return (
        <Badge
          display='flex'
          flexDir='row'
          alignItems='center'
          colorScheme='linkedin'
          gap={1}
        >
          <FiCheckCircle />
          <Text>Publicada</Text>
        </Badge>
      )
    }

    if (status === SurveyStatus.CLOSED) {
      return (
        <Badge
          display='flex'
          flexDir='row'
          alignItems='center'
          colorScheme='green'
          gap={1}
        >
          <FiCheckCircle />
          <Text>Finalizada</Text>
        </Badge>
      )
    }

    return (
      <Badge
        display='flex'
        flexDir='row'
        alignItems='center'
        colorScheme='gray'
        gap={1}
      >
        <FiFileText />
        <Text>Borrador</Text>
      </Badge>
    )
  }

  return (
    <Card
      minW={340}
      width={340}
      height={112}
      px={4}
      py={3}
      display='flex'
      justifyContent='space-between'
    >
      <Stack>
        <HStack
          display='flex'
          justifyContent='space-between'
          height={0}
          pt={5}
          gap={3}
        >
          <Heading size='sm' noOfLines={1} textTransform='capitalize'>
            {title}
          </Heading>
          {
            isAdmin && (
              <HStack>
                <Tooltip label='Borrar encuesta'>
                  <IconButton
                    isRound
                    size='sm'
                    aria-label='delete'
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onDelete(id)
                    }}
                  >
                    <FiTrash2 color='brand.500' />
                  </IconButton>
                </Tooltip>
                <Tooltip label='Editar encuesta'>
                  <IconButton
                    isRound
                    size='sm'
                    aria-label='editar'
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onClick(id)
                    }}
                  >
                    <FiEdit3 color='brand.500' />
                  </IconButton>
                </Tooltip>
              </HStack>
            )
          }
        </HStack>
        <Text fontSize='xs' color='GrayText'>
          {formatDate(createdAt)}
        </Text>
      </Stack>
      <HStack justify='space-between'>
        {getStatusLabel()}
        <HStack color='gray.500'>
          <Icon as={FiUsers} />
          <Text fontSize='xs'>
            <b>{responses}</b>
          </Text>
        </HStack>
      </HStack>
    </Card>
  )
};

export default SurveyCard;
